import React from 'react';
import { Button, Upload, UploadFile, message } from 'antd';
import axios from 'axios';
import client from '@/lib/feathers';
import dayjs from 'dayjs';
import type { UploadedFileInfo } from '../types';

interface UploadFileForAnnouncementProps {
  updateUploadFileInfo: (fileInfo: UploadedFileInfo) => void;
}

const UploadFileForAnnouncement = ({
  updateUploadFileInfo,
}: UploadFileForAnnouncementProps) => {
  const uploadsService = client.service('uploads');

  const uploadFiles = (dbName: string, file: string | Blob) => {
    const formData = new FormData();
    formData.append('files', file);
    const res = axios.post(
      `/newUploads?type=${dbName}&isConvertPng=false`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: localStorage.getItem('feathers-jwt'),
        },
      }
    );
    return res;
  };
  const customRequest = async (options: { file: any; onSuccess?: any }) => {
    const { onSuccess, file } = options;
    if (file.size > 1024 * 1024 * 20) {
      message.error('上傳檔案不能超過20MB');
      return;
    }
    try {
      const res = await uploadFiles('groupBuying', options.file);
      const fileInfo = { file, fileResponse: res.data };
      updateUploadFileInfo(fileInfo);
      onSuccess(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const deleteFile = (file: UploadFile<any>) => {
    updateUploadFileInfo({
      file: { uid: '', name: '' },
      fileResponse: {
        _id: '',
        oldName: '',
        orignalName: '',
        newNameWithPath: '',
        showPath: '',
        type: '',
        uid: '',
        compressImagePath: '',
        createAt: dayjs().unix(),
        png: [],
      },
    });
    return uploadsService.remove(file.response._id);
  };

  return (
    <Upload
      showUploadList
      maxCount={1}
      customRequest={customRequest}
      onRemove={async (file) => {
        try {
          await deleteFile(file);
          message.success('圖片移除成功！');
        } catch (err) {
          console.error({ err });
        }
      }}
    >
      <Button>檔案上傳</Button>
    </Upload>
  );
};

export default UploadFileForAnnouncement;
